import { z } from 'zod';

export default {
  label: 'First-Order Properties', group: 'system',
  description: 'First-order properties: focal lengths, conjugates and pupils. ANG is the last field’s object-space angle, in degrees.',
  settingsSchema: z.strictObject({}),
  parameters: [],
  coverage: 'Settings come from the lens. EFL and BFL are signed by the direction of travel: after an odd number of reflections the light leaves the last surface travelling in -Z, and they are negative where the unfolded lens would give positive values (EFL -100 for a 100 mm lens followed by a fold mirror). First-Order ABCD Properties can report the opposite sign. Angular magnification of afocal systems is not reported.',
} as const;
